import axios, {AxiosResponse} from 'axios'
import { SettingsQueryResponse } from './_modesl'
import { ChatQueryResponse } from '../../chats/chat-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const SETTINGS = `${API_URL}/companies/settings/`
const SETTINGSADMIN = `${API_URL}/companies/settingsadmin/`
const GENERATE_TOKEN = `${API_URL}/companies/generate/`
const UPLOAD_MEDIA = `${API_URL}/upload`


const getSettings = (id: string): Promise<any> => {
  return axios
    .get(`${SETTINGSADMIN}${id}`)
    .then((d: AxiosResponse<any>) => d.data.data)
}


const updateSettings = (data: any, id: string): Promise<any | undefined> => {
  return axios
    .patch(`${SETTINGS}${id}`, data)
    .then((response: AxiosResponse<Response>) => response.data)
    .then((response: Response) => response)
}

const generateToken = (id: string): Promise<any | undefined> => {
  return axios
    .patch(`${GENERATE_TOKEN}${id}`)
    .then((response: AxiosResponse<Response>) => response.data)
    .then((response: Response) => response)
}



const uploadProfile = async (data: any) => {
  const formData = new FormData();
  formData.append("file", data);
  // return axios
  //   .post(`${UPLOAD_MEDIA}`, data)
  //   .then((response: AxiosResponse<Response>) => response.data)
  //   .then((response: Response) => response)
  const response = await axios({
    method: "post",
    url: UPLOAD_MEDIA,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
}


export {getSettings,updateSettings,uploadProfile,generateToken}
